import { render, staticRenderFns } from "./GalleryHeader.vue?vue&type=template&id=52d8e295&scoped=true&"
import script from "./GalleryHeader.vue?vue&type=script&lang=js&"
export * from "./GalleryHeader.vue?vue&type=script&lang=js&"
import style0 from "./GalleryHeader.vue?vue&type=style&index=0&id=52d8e295&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d8e295",
  null
  
)

export default component.exports